module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ControlCenterView.js"));
	}, "ControlCenterView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ControlCenterView!./src/pages/Shop/Product/ControlCenter/ControlCenterView.js
// module id = 1821
// module chunks = 367